<div class="tray-overlay" (click)="overlayClick.emit()" [@overlay]="shown"> </div>
